import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const DueOn = ({ control, name, onSelectChange, dashboardBg }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [countriesData, setCountriesData] = useState([])

  const loadOptions = async () => {
    const data = [
      { label: "< 30 Days", value: "pending_less_than_30_days" },
      { label: "30 to 60 Days", value: "pending_30_to_60_days" },
      { label: "60 to 90 Days", value: "pending_60_to_90_days" },
      { label: "> 90 Days", value: "pending_greater_than_90_days" },
    ]
    setIsLoading(false)
    const countries = data.map(dta => {
      return {
        label: dta?.label && ucfirst(dta.label),
        value: dta.value,
        ...dta,
      }
    })

    setCountriesData(countries)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={countriesData}
              placeholder={"Due On"}
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className={`elevate-dropdown ${
                dashboardBg ? "elevate-dropdown-new-bg" : ""
              }`}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          )
        }}
      />
    </div>
  )
}

export default DueOn
